var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useGetJoinContext } from './useGetJoinContext';
import { ERRORS } from '../components/JoinByInvite/constants';
import { useJoinTeamAccountsV2 } from './useJoinTeamAccountsV2';
import { EXTERNAL_ROUTES } from '../constants/values';
import { mapJoinTeamAccountsErrorToPageError } from '../components/JoinByInvite/JoinByInviteUtils';
import track from '../utils/track';
import { JoinV2PageEvents } from '../constants/events/names';
var useJoinByInvite = function (pendingMemberId, forceSkip) {
    if (forceSkip === void 0) { forceSkip = false; }
    var _a = __read(React.useState(null), 2), errorType = _a[0], setErrorType = _a[1];
    var _b = useJoinTeamAccountsV2(), joinTeamAccountsV2 = _b.joinTeamAccountsV2, joinTeamAccountsV2Loading = _b.loading, joinTeamAccountsV2Data = _b.data;
    var _c = useGetJoinContext({
        invitationCode: pendingMemberId,
        forceSkip: forceSkip,
    }), getJoinContextLoading = _c.loading, getJoinContextData = _c.data, getJoinContextError = _c.error;
    var joinByInvite = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!getJoinContextLoading && !getJoinContextError)) return [3 /*break*/, 2];
                    return [4 /*yield*/, joinTeamAccountsV2(pendingMemberId, {
                            onCompleted: function (response) {
                                var _a, _b, _c, _d;
                                if ((_a = response === null || response === void 0 ? void 0 : response.joinTeamAccountsV2) === null || _a === void 0 ? void 0 : _a.success) {
                                    track(JoinV2PageEvents.WORK_PORTAL_JOIN_PAGE_V2_JOIN_TEAM_ACCOUNT_SUCCESS, {
                                        pending_member_id: pendingMemberId,
                                        team_member_id: (_c = (_b = response === null || response === void 0 ? void 0 : response.joinTeamAccountsV2) === null || _b === void 0 ? void 0 : _b.teamMember) === null || _c === void 0 ? void 0 : _c.id,
                                        is_personal_login_allowed: getJoinContextData.getJoinContext.isPersonalLoginAllowed,
                                        is_consumer_email_match: getJoinContextData.getJoinContext.isConsumerEmailMatch,
                                    });
                                    window.location.href = EXTERNAL_ROUTES.BENEFITS_PAGE + "?joinV2=true";
                                }
                                else {
                                    var pageErrorCode = mapJoinTeamAccountsErrorToPageError((_d = response.joinTeamAccountsV2) === null || _d === void 0 ? void 0 : _d.error);
                                    track(JoinV2PageEvents.WORK_PORTAL_JOIN_PAGE_V2_JOIN_TEAM_ACCOUNT_FAILURE, {
                                        pending_member_id: pendingMemberId,
                                        error_type: pageErrorCode,
                                        is_personal_login_allowed: getJoinContextData.getJoinContext.isPersonalLoginAllowed,
                                        is_consumer_email_match: getJoinContextData.getJoinContext.isConsumerEmailMatch,
                                    });
                                    setErrorType(pageErrorCode);
                                }
                            },
                            onError: function () {
                                track(JoinV2PageEvents.WORK_PORTAL_JOIN_PAGE_V2_JOIN_TEAM_ACCOUNT_FAILURE, {
                                    pending_member_id: pendingMemberId,
                                    error_type: ERRORS.somethingWentWrong,
                                    is_personal_login_allowed: getJoinContextData.getJoinContext.isPersonalLoginAllowed,
                                    is_consumer_email_match: getJoinContextData.getJoinContext.isConsumerEmailMatch,
                                });
                                setErrorType(ERRORS.somethingWentWrong);
                            },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        joinByInvite: joinByInvite,
        errorType: errorType,
        getJoinContextLoading: getJoinContextLoading,
        getJoinContextData: getJoinContextData === null || getJoinContextData === void 0 ? void 0 : getJoinContextData.getJoinContext,
        joinTeamAccountsV2Loading: joinTeamAccountsV2Loading,
        joinTeamAccountsV2Data: joinTeamAccountsV2Data === null || joinTeamAccountsV2Data === void 0 ? void 0 : joinTeamAccountsV2Data.joinTeamAccountsV2,
    };
};
export default useJoinByInvite;
